var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a-html", { attrs: { autoEnable: "false" } }, [
    _c("div", { staticClass: "vr" }, [
      _c("h1", [
        _vm._v("\n        " + _vm._s(_vm.block.field_values.text) + "\n      "),
      ]),
      _vm._v(" "),
      _c("div", {
        domProps: { innerHTML: _vm._s(_vm.block.field_values.html) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }